import React, { useEffect } from 'react';
import { useMediaQuery, CircularProgress } from "@material-ui/core";
import { customTheme } from "./customTheme";
import config from "./config.json";
import notify from './components/CustomUseNotify';
import { stringify } from 'query-string';
import { useHistory } from "react-router-dom";
import { saveTokens } from './utils/saveTokens';

const VehicleSummaryRedirect = () => {
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const history = useHistory();

    const fetchParkings = () => {
        var params = {
            user_id: sessionStorage.getItem("user_id"),
            filter: JSON.stringify({ includeSocieties: true }),
            page: 1,
            perPage: 1
        }
        fetch(`${config.HOST_NAME}/crm/v3/parkings?${stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then((responseJson) => {
                if (responseJson.success && responseJson.data.length > 0) {
                    history.replace(`/parkings/${responseJson.data[0].id}/show`);
                } else {
                    notify(responseJson.message, 'warning');
                    history.replace(`/parkings`);
                }
            })
            .catch((e) => {
                notify('Error fetching Parkings', 'warning');
                history.replace(`/parkings`);
            });
    };

    useEffect(() => {
        fetchParkings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div style={{ padding: isSmallDevice ? "0 22px 25px" : "25px 22px", display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <CircularProgress size={50} />
        </div>
    )
}
export default VehicleSummaryRedirect;